// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ff08849b","147":"d90a7e9d","354":"76811bcb","362":"496c5b2e","584":"3f4d8be7","615":"32934237","807":"494554d4","818":"7b347f95","899":"f9c7df09","900":"a8d08fcf"}[chunkId] + ".chunk.js";
};